import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import classNames from 'classnames'

import './styles.css'

class Button extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    to: PropTypes.string,
    href: PropTypes.string,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    color: PropTypes.string,
    size: PropTypes.string,
    layout: PropTypes.oneOf(['transparent', 'rounded']),
    iconPosition: PropTypes.oneOf(['left', 'right']),
    isStretch: PropTypes.bool,
    target: PropTypes.string,
    style: PropTypes.object,
    isUppercase: PropTypes.bool
  }

  static defaultProps = {
    type: 'button',
    color: 'gray',
    size: 'lg',
    target: '_self',
    dashed: false,
    isUppercase: true
  }

  renderChildren() {
    const { children, iconPosition } = this.props
    return (
      <div
        className={classNames({
          'butn-inner': true,
          'butn-inner--icon-left': iconPosition === 'left',
          'butn-inner--icon-right': iconPosition === 'right'
        })}
      >
        {children}
      </div>
    )
  }

  render() {
    const {
      className,
      onClick,
      type,
      disabled,
      to,
      href,
      color,
      size,
      isStretch,
      target,
      style,
      layout,
      isUppercase,
      iconPosition
    } = this.props

    const butnClasses = classNames(
      {
        butn: true,
        'butn--red': color === 'red',
        'butn--white': color === 'white',
        'butn--green': color === 'green',
        'butn--blue': color === 'blue',
        'butn--gray': color === 'gray',
        'butn--gold': color === 'gold',
        'butn--gold-gradient': color === 'gold-gradient',
        'butn--current-color': color === 'currentColor',
        'butn--transparent': layout === 'transparent',
        'butn--rounded': layout === 'rounded',
        'butn--xs': size === 'xs',
        'butn--sm': size === 'sm',
        'butn--md': size === 'md',
        'butn--lg': size === 'lg',
        'butn--xlg': size === 'xlg',
        'butn--stretch': isStretch,
        'butn--uppercase': isUppercase,
        'butn--with-icon': !!iconPosition
      },
      className
    )

    if (to) {
      return (
        <Link
          to={to}
          role="button"
          className={butnClasses}
          disabled={disabled}
          style={style}
        >
          {this.renderChildren()}
        </Link>
      )
    }

    if (href) {
      return (
        <a
          href={href}
          role="button"
          className={butnClasses}
          onClick={onClick}
          disabled={disabled}
          target={target}
          style={style}
        >
          {this.renderChildren()}
        </a>
      )
    }

    return (
      <button
        type={type}
        className={butnClasses}
        onClick={onClick}
        disabled={disabled}
        style={style}
      >
        {this.renderChildren()}
      </button>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/button/button.js